function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".spCIPullRequestClosed_svg__st0{fill:none}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.1 0C6.3 0 8 1.8 8 4c0 1.7-1 3.1-2.6 3.7-.1 0-.2.1-.3.1S5 7.9 5 8v7.9c0 .1.1.3.2.3 1.3.4 2.3 1.5 2.7 2.8.2.7.2 1.3 0 2-.3 1.2-1.2 2.2-2.3 2.7-.8.3-1.7.4-2.6.2-1.2-.3-2.2-1.2-2.6-2.3-.3-.6-.4-1.3-.3-2 .2-1.4 1-2.6 2.3-3.2.2-.1.3-.1.5-.2.1 0 .1-.1.1-.2V8.1c0-.1-.1-.3-.2-.3C1.7 7.5.7 6.6.3 5.5-.4 3.9.1 2 1.4.9 2.2.3 3.1 0 4.1 0zM23.9 1.4L22.5 0l-2.6 2.5L17.4 0 16 1.4 18.5 4 16 6.5l1.4 1.4 2.5-2.5 2.6 2.5 1.4-1.4L21.3 4z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "spCIPullRequestClosed_svg__st0",
  d: "M19.9 17.8c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2h.2c1.2-.1 2-1 2-2.2 0-1.2-1-2.2-2.2-2.2z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "spCIPullRequestClosed_svg__st0",
  d: "M19.9 17.8c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2h.2c1.2-.1 2-1 2-2.2 0-1.2-1-2.2-2.2-2.2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.6 18.3c-.5-1-1.4-1.7-2.4-2.1-.1 0-.2-.2-.2-.3V9.2h-2V16c0 .1 0 .2-.1.2-.2 0-.3.1-.5.2-1.2.5-2 1.6-2.3 2.8-.2.8-.1 1.6.2 2.3.5 1.1 1.4 2 2.6 2.3.9.2 1.8.2 2.6-.2 1.1-.5 2-1.4 2.3-2.6.3-.9.2-1.9-.2-2.7zm-3.5 3.9h-.2c-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2 2.2 1 2.2 2.2c.1 1.2-.8 2.1-2 2.2z"
});

function SvgSpCiPullRequestClosed(props) {
  return React.createElement("svg", _extends({
    id: "spCIPullRequestClosed_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default __webpack_public_path__ + "spCIPullRequestClosed.c9b9d.svg";
export { SvgSpCiPullRequestClosed as ReactComponent };